import { createContext, Dispatch, SetStateAction, useContext } from "react";
import { FilterBody, FilterProps } from "../../../hooks/filter/typing";
import { InputModel } from "../../../utils/types";

const UserScheduleContext = createContext<{
    filterData: FilterBody
    setFilterPayload: Dispatch<SetStateAction<FilterProps>>
    userSchedule: FilterBody
    userFilterData: any
    disabledInputs: (data: {
        inputs: string[];
        value: boolean;
    }) => void
    input: {
        [x: string]: InputModel;
    }
}>(Object({}))

const useUserScheduleContext = () => useContext(UserScheduleContext)
export { UserScheduleContext, useUserScheduleContext }
